import { render, staticRenderFns } from "./openAiRequests.vue?vue&type=template&id=64263560&scoped=true&"
import script from "./openAiRequests.vue?vue&type=script&lang=js&"
export * from "./openAiRequests.vue?vue&type=script&lang=js&"
import style0 from "./openAiRequests.vue?vue&type=style&index=0&id=64263560&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64263560",
  null
  
)

export default component.exports